(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/match-init-box-light/helpers/match-init-helper.js') >= 0) return;  svs.modules.push('/components/sport/match-init-box-light/helpers/match-init-helper.js'); 
'use strict';

(function() {
  var isServer = typeof exports === 'object';

  registerHelpers(!isServer ? Handlebars : require('hbs'));

  function registerHelpers(hbs) {
    hbs.registerHelper('initBoxLite', function(data, isHorizontal) {
      var stackClass = isHorizontal ? ' init-horizontal' : ' align-center',
        ret = '';
      if (isServer) {
        return new hbs.SafeString(
          '<div class="match-init' +
            stackClass +
            '"><div class="match-init--is-loading">Laddar</div></div>'
        );
      }

      if (!data) {
        return new hbs.SafeString(
          '<div class="match-init' +
            stackClass +
            '"><i class="init-icon icon-default"></i></div>'
        );
      }

      if (data.error) {
        return new hbs.SafeString(
          '<div class="match-init' +
            stackClass +
            '"><i class="init-icon icon-default icon-exclamation-sign brick"></i></div>'
        );
      }

      ret += getStoppageInfo(data, stackClass);

      if (!data.hideMatchInfo) {
        ret += getMatchInfo(data, stackClass);
      }

      return new hbs.SafeString(ret);
    });

    function isNumber(obj) {
      return typeof obj === 'number';
    }

    function getMatchInfo(data, stackClass) {
      var ret = '',
        live = '',
        isLive = getTemplateFunction('isLive', data.sport, data.status.id),
        isEnded = getTemplateFunction('isEnded', data.sport, data.status.id),
        matchStatus = isNumber(data.status.id) ? data.status.id : '',
        matchId = isNumber(data.matchId) ? data.matchId : '',
        matchInfo = '';

      data.timeId = new Date().getTime();

      if (data.status.text) {
        matchInfo =
          '<div class="brick match-status brick-active f-condensed align-center">' +
          data.status.text +
          '</div>';
      } else {
        matchInfo = getTemplateFunction('initStatusStart', data.sport, data);
      }

      if (isLive) {
        live = 'match-live';
      } else if (!!data.opt.startedLiveDraw && !isEnded) {
        live = 'match-live live-draw';
      }

      ret +=
        '<div data-init-time-status="' +
        data.timeId +
        '" data-init-id="' +
        matchId +
        '" data-match-status="' +
        matchStatus +
        '" class="match-init ' +
        live +
        stackClass +
        '">';

      if (
        (data.opt.tv && !isEnded) ||
        (data.opt.live && !isEnded) ||
        data.opt.date
      ) {
        ret += '<div class="top-init">';
        ret +=
          data.opt.tv && !isEnded
            ? '<i class="icon-default icon-tv"title ="' +
              getTvChannels(data.opt.tv) +
              '"></i>'
            : '';
        ret +=
          data.opt.live && !isEnded
            ? '<span class="init-live-bet f-condensed">LIVESPEL</span>'
            : '';
        ret += getStartText(data);
        ret +=
          data.opt.date && !isLive
            ? getDate(new Date(data.startTime), true)
            : '';
        ret += '</div>';
      }

      ret += matchInfo;
      ret += '</div>';

      return ret;
    }

    function getStoppageInfo(data, stackClass) {
      var ret = '',
        isLive = getTemplateFunction('isLive', data.sport, data.status.id),
        isEnded = getTemplateFunction('isEnded', data.sport, data.status.id),
        cssClasses = '',
        spelstoppDate;

      if (!!data.opt.spelstopp && (!isLive && !isEnded)) {
        spelstoppDate = new Date(data.opt.spelstopp);
        cssClasses += data.opt.tv ? ' has-tv' : '';
        cssClasses += data.opt.live ? ' has-live-bet' : '';

        ret += '<div class="spelstopp-init' + cssClasses + stackClass + '">';
        ret +=
          data.opt.tv && data.hideMatchInfo
            ? '<i class="icon-default icon-tv" title ="' +
              getTvChannels(data.opt.tv) +
              '"></i>'
            : '';
        ret +=
          data.opt.live && data.hideMatchInfo
            ? '<span class="init-live-bet f-condensed">LIVESPEL</span>'
            : '';
        ret += getStoppageTime(spelstoppDate);
        ret +=
          '<span class="brick brick-inactive brick-border f-condensed align-center">';
        ret += spelstoppDate.toTimeString().slice(0, 5);
        ret += '</span>';
        ret += '</div>';
      }

      return ret;
    }

    function getStoppageTime(time) {
      var ret = '',
        dateText = getDate(time, true, false);

      if (dateText) {
        ret += '<span class="init-date init-date-outer">';
        ret += dateText;
        ret += '</span>';
      }

      return ret;
    }

    function getStartText(data) {
      var hasStarted = getTemplateFunction(
        'hasStarted',
        data.sport,
        data.status.id
      );

      if (data.showStartText && !hasStarted) {
        return '<span class="init-date f-condensed align-center text-date">Startar</span>';
      }
      return '';
    }

    function getDate(time, text, toDayText) {
      var nowStartOfDay = new Date(),
        diff;

      nowStartOfDay.setHours(0, 0, 0, 0);
      if (time) {
        if (text) {
          diff = Math.floor(
            (time.getTime() - nowStartOfDay.getTime()) / (1000 * 60 * 60 * 24)
          );
          if (diff === 1) {
            return '<span class="init-date f-condensed align-center"><span class="text-date">Imorgon</span></span>';
          } else if (diff === 0) {
            if (toDayText) {
              return '<span class="init-date f-condensed align-center"><span class="text-date">Idag</span></span>';
            }
            return '';
          } else if (diff < 0) {
            return ''; 
          }
        }
        return (
          '<span class="init-date f-condensed align-center">' +
          time.getDate() +
          '/' +
          (time.getMonth() + 1) +
          '</span>'
        );
      }
    }

    function getTemplateFunction(func, sportId, args) {
      var resultCheck = false,
        themeLoader = _getThemeLoader(),
        theme = new themeLoader({ sport: sportId });

      theme.load(function(template, init) {
        if (init) {
          resultCheck = init(func, args);
        }
      }, 'init');

      return resultCheck;
    }

    function _getThemeLoader() {
      var themeLoader;
      if (!isServer) {
        themeLoader = svs.sport.themeLoader;
      } else {
        var trinidad = require('trinidad-core').core;
        themeLoader = trinidad.components.require('sport', 'theme').api;
      }

      return themeLoader;
    }

    function getTvChannels(tvData) {
      var tvChannels = '',
        tvChannelsArr = [];

      if (Array.isArray(tvData)) {
        tvData.forEach(function(obj) {
          tvChannelsArr.push(obj.channelName);
        });
      }

      tvChannels = tvChannelsArr.join(', ');

      return tvChannels;
    }
  }
})();

 })(window);